//Still used in Asset Allocation

var editor;

var planNotes = {
  createModal: function ($self, e) {
    e.preventDefault();

    var modal = $('#notes-dialog');

    if (modal.length === 0) {
      modal = $("<div id='notes-dialog' class='simplemodal-overlay' style='display:none;'></div>");
      $('body').append(modal);
    }

    $.ajax(
    {
      type: 'GET',
      url: $self.attr('href'),
      dataType: 'json',
      cache: false,
      success: function (data, textStatus, jqXHR) {
        $(modal)
        .html(data.Html)
        .modal(
          {
          onShow: function (dialog) {
            planNotes.init(); //plan notes
            $(dialog.data).find('.btn')
              .addClass('btn-primary btn-xs')
                .wrap('<span class="bootstrap-wrapper"></span>');
              $('.simplemodal-wrap').css('height', '99%');
          },
          onClose: function () {
            $.modal.close();
            modal.remove();
          },
          closeHTML: "<div class='bootstrap-wrapper'><a href='#' aria-label='Close' class='modal-close pull-right'><i class='fa fa-times' aria-hidden='true'></i></a></div>",
          minHeight: 800,
          minWidth: 900,
          maxHeight: 800,
          maxWidth: 900,
          close: true
        });
      }
    });
    return false;
  },

  init: function () {
    this.updateRoute = $('.editor_create').attr("href");
    this.deleteRoute = $('.editor_remove').attr("href");
    var envelopeConf = $.fn.DataTable.Editor.display.envelope.conf;
    envelopeConf.attach = 'head';
    envelopeConf.windowScroll = false;
    var date = new Date();
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    if (dd < 10) { dd = '0' + dd } if (mm < 10) { mm = '0' + mm } date = mm + '/' + dd + '/' + yyyy;

    editor = new $.fn.DataTable.Editor({
      "ajax": function (method, url, data, success, error) {
        var table = planNotes.GetTable();
        planNotes.update(data);

        if (data.action == 'edit') {
          var index = table.row(editor.modifier()).index();
          table.row(index).data(data.data);
        }
        success(data.data);
        BindElements();
      },
      "legacyAjax": true,  //new and necessary for 1.5
      "table": '#planNotesTable',
      "idSrc": 'NoteId',  //new and necessary for 1.5
      "display": "envelope",
      "fields": [{
        "name": "DateCreated",
        "default": date.toString(),
        "type": "hidden"
      },
      {
        "name": "Contents",
        "type": "textarea",
        "default": ""
      },
      {
        "name": "NoteId",
        "default": null,
        "type": "hidden"

      }],
      "events": {
        onPreClose: function (e, trigger) {
          //Prevent user from clicking on background above the open envelope and causing the envelope to close.
          if (e == 'background')
            return false;
        },
        onClose: function () {
          halt = true;

        },
        onOpen: function () {
          var $envelopeWrapper = $('div.DTED_Envelope_Wrapper');
          var $envelopeClose = $('.DTED_Envelope_Close');

          //Added to make envelope open at correct location (under header of datatable) when page has been scrolled down.
          var top = parseFloat($envelopeWrapper.css('top').replace('px', '')) - parseFloat($(document).scrollTop()) + 'px';

          $envelopeWrapper.css('top', top);

          var $bootboxModalBodyElem = $('.notes-modal').find('.modal-body');

          if ($bootboxModalBodyElem.length) {
            var parentModalWidth = $bootboxModalBodyElem.width();
            $envelopeWrapper.css('width', parentModalWidth);
            $envelopeWrapper.css('margin-left', -(parentModalWidth / 2));
            //Without removing the tabIndex input field aren't editable
            $('.notes-modal').removeAttr("tabindex");
          }

          if ($bootboxModalBodyElem.length) {
            $envelopeClose.remove('button');
            $envelopeClose.text('').append('<button class="btn btn-primary">Close</button>');
          } else {
            $envelopeClose.text('Close')
          }
        }
      }
    });


    var table = $('#planNotesTable').DataTable({
      "aoColumnDefs": [
                  {
                    "sTitle": "Created",
                    "mData": "DateCreated",
                    "sDefaultContent": "",
                    "bSortable": true,
                    "sType": "date",
                    "aTargets": [0],
                    "sClass": "date-area",
                    "sWidth": "90px",
                    "mRender": function (data, type, full) {
                      return data;
                    }
                  },
                  {
                    "bSortable": false,
                    "sTitle": "Note",
                    "mData": "Contents",
                    "sDefaultContent": "",
                    "aTargets": [1],
                    "sClass": "text-area",
                    "bSearchable": true,
                    "sWidth": "565px",
                    "mRender": function (data, type, full) {
                      return data;
                    }
                  },
                  {
                    "bSortable": false,
                    "sTitle": "",
                    "mData": "NoteId",
                    "sDefaultContent": "",
                    "aTargets": [2],
                    "bVisible": true,
                    "sWidth": "45px",
                    "mRender": function (data, type, full) {
                      return "<a class='edit-item editor_edit'></a><a class='delete-item editor_remove'></a>";
                    }
                  }
      ],
      "bDestroy": true,
      "sDom": '<"top">rt<"bottom"flp><"clear">',
      "sScrollY": "300px",
      "bPaginate": false,
      "bLengthChange": false,
      "bFilter": true,
      "bAutoWidth": true,
      "bProcessing": true,
      "bSort": true,
      "aaSorting": [[0, 'desc']],
      "iDisplayLength": 2,
      "oLanguage": {
        "sEmptyTable": "You have not saved any notes for this plan."
      }
    });

    $('#planNotesTable_filter').find('input').addClass('form-control');
    $('#plan-notes-loading').addClass('hidden');

    table.draw(); //fixes table header misalignment

    $('#data-table-container').css('visibility', 'visible'); //prevent FOUC
    
    BindElements();

    return this;
  },
  update: function (row) {
    var postModel = this.MapJson(row.data);

    $.ajax({
      contentType: "application/json",
      data: postModel,
      dataType: "json",
      success: function (response) {
        onResultsReceived(response, row);
        var table = planNotes.GetTable();
        var data = row.data;
        data.NoteId = response.id;
        if (row.action == 'create') {
          table.row.add(data);
          $('#ai-summary').removeClass('hidden');
        }
        table.draw();
        BindElements();
        editor.close();
        return;
      },
      type: 'POST',
      url: planNotes.updateRoute
    });
    return;
  },
  deleteRow: function (row) {
    var table = planNotes.GetTable();
    var data = table.row(row).data();
    var postModel = planNotes.MapJson(data);

    $.ajax({
      contentType: "application/json",
      dataType: "json",
      success: function (response) {
        onDeleteReceived(response.success, row);
        BindElements();
        return;
      },
      data: postModel,
      type: 'POST',
      url: planNotes.deleteRoute
    });

    return;
  },
  MapJson: function (data) {
    var note = new Object();

    note.Contents = data.Contents;
    note.DateCreated = data.DateCreated;
    note.NoteId = data.NoteId;
    return JSON.stringify(note);
  },
  GetTable: function () {
    return $('#planNotesTable').DataTable();
  }


}
function onResultsReceived(response, row) {
  var results = response.success;

  if (!results)
    $(row).addClass('delete-row-cue');

  return;
}
function onDeleteReceived(success, row) {
  var results = success;

  if (!results) {
    $(row).addClass('delete-row-cue');
    return;
  }
  $(row).addClass('delete-row-cue').toggle('highlight').promise().done(function () {
    const table = planNotes.GetTable();

    table.row(this).remove().draw();

    if (table.rows().count() < 1) {
      $('#ai-summary').addClass('hidden');
    }
  });
  return;
}

function BindElements() {
  var $promptTextarea = $('#summarize-prompt');
  var currentPrompt = $promptTextarea.val();

  $('.prompt-suggestion').each(function () {
    var $btn = $(this);
    if ($btn.data('prompt') === currentPrompt) {
      $btn.removeClass('btn-default-outline').addClass('btn-default active');
    } else {
      $btn.removeClass('btn-default active').addClass('btn-default-outline');
    }
  });

  $('.prompt-suggestion:not(.bound)').addClass('bound').on('click', function (e) {
    e.preventDefault();
    var $clicked = $(this);
    $promptTextarea.val($clicked.data('prompt'));
    $('.prompt-suggestion').removeClass('btn-default active').addClass('btn-default-outline');
    $clicked.removeClass('btn-default-outline').addClass('btn-default active');
  });

  $('#summarize-notes-btn:not(.bound)').addClass('bound').on('click', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var originalText = $btn.text();
    var $summaryError = $('#summary-error');
    var $summaryContent = $('#summary-content');
    var $summaryContainer = $('#summary-container');

    $btn.text('Summarizing...').prop('disabled', true);

    var customPrompt = $('#summarize-prompt').val();

    $.ajax({
      type: 'POST',
      url: $('#SummarizeUrl').val(),
      data: JSON.stringify({ customPrompt: customPrompt }),
      contentType: 'application/json',
      dataType: 'json',
      success: function (response) {
        if (response.success) {
          $summaryError.hide();
          $summaryContent.html(DOMPurify.sanitize(marked.parse(response.summary)));   //convert markdown to html
          $summaryContainer.show();
        } else {
          $summaryContainer.hide();
          $summaryError.text(response.message || 'Failed to generate summary.').show();
        }
      },
      error: function () {
        $summaryContainer.hide();
        $summaryError.text('Error occurred while generating summary.').show();
      },
      complete: function () {
        $btn.text(originalText).prop('disabled', false);
      }
    });
  });

  $('a.editor_create:not(.bound)').addClass('bound').on('click', function (e) {
    e.preventDefault();
    editor.create(
          'Add New Note',
          {
            "label": "Done",
            "fn": function () {
              var $frm = $('div.DTED_Envelope_Wrapper').find('form');

              $frm.validate();

              if ($frm.valid()) {
                editor.submit();
              }

              BindElements();
            }
          }
      );

    var $fieldContentsElem = $('#DTE_Field_Contents');

    $('div.DTED_Envelope_Wrapper').find('form').validate().resetForm();
    $fieldContentsElem.closest('.form-group').removeClass('has-error');

    $('.DTE_Form_Buttons').find('button').addClass('btn btn-primary');
    $fieldContentsElem.prop('required', true).addClass('form-control');

    if (!$fieldContentsElem.parent().hasClass('form-group')) {
      $fieldContentsElem.wrap("<div class='bootstrap-wrapper'><div class='form-group'></div></div>");
    }
  });

  $('#cancel:not(.bound)').addClass('bound').on('click', function () {
    var $bootboxModal = $('.notes-modal');

    if ($bootboxModal.length) {
      $('.notes-modal').modal('hide');
    }
    else {
      $.modal.close();
    }
    editor.close();
    $('body').removeClass('#notes-dialog');
  });


  $('.delete-item:not(.bound)').addClass('bound').on('click', function (e) {
    var $self = $(this);

    e.preventDefault();

    if (confirm("Are you sure you want to delete this note?")) { 
      planNotes.deleteRow($self.closest('tr')[0]);
    }
  });

  $('a.editor_edit:not(.bound)').addClass('bound').on('click', function (e) {
    e.preventDefault();

    editor.edit(
        $(this).closest('tr')[0],
        'Edit Note',
        {
          "label": "Update",
          "fn": function () {
            var $frm = $('div.DTED_Envelope_Wrapper').find('form');

            $frm.validate();

            if ($frm.valid()) {
              editor.submit();
            }
          }
        }
    );
    var $fieldContentsElem = $('#DTE_Field_Contents');

    $('div.DTED_Envelope_Wrapper').find('form').validate().resetForm();
    $fieldContentsElem.closest('.form-group').removeClass('has-error');

    $('.DTE_Form_Buttons').find('button').addClass('btn btn-primary');
    $fieldContentsElem.prop('required', true).addClass('form-control');

    if (!$fieldContentsElem.parent().hasClass('form-group')) {
      $fieldContentsElem.wrap("<div class='bootstrap-wrapper'><div class='form-group'></div></div>");
    }
  });
  return;
}

document.addEventListener('DOMContentLoaded', function () {
  $('.notes-link:not(.bound)').addClass('bound').on('click', function () {
    planNotes.createModal($(this), event);
    return false;
  });
});
